<template>
  <v-container fluid class="lighten-12 content">
    <v-data-table
      :fixed-header="true"
      :headers="toporderproduct"
      :items="TopOrderProduct"
      item-key="id"
      hide-default-footer
    >
      <!-- Image -->

      <template v-slot:item.product.image="{ item }">
        <img
          v-if="item.product.image"
          :src="item.product.image"
          height="32"
          width="32"
          class="image"
        />
        <v-avatar v-else size="32px" item color="primary">
          <span class="white--text subtitle-2 text-uppercase">
            {{ item.product.name.substring(0, 2) }}</span
          >
        </v-avatar>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import axios from "@/plugins/axios";

export default {
  name: "Home",

  data: () => ({
    toporderproduct: [
      {
        value: "product.image",
        show: true,
        disabled: true,

        width: "14%",
      },
      {
        text: "Code",
        value: "product.code",
        align: "left",
        show: true,
        disabled: true,
        width: "14%",
      },
      {
        text: "Name",
        value: "product.name",
        show: true,
        align: "left",
        disabled: false,
        width: "14%",
      },
      {
        text: "Quantity",
        value: "quantity",
        show: true,
        align: "left",
        disabled: false,
        width: "14%",
      },
    ],

    TopOrderProduct: [],
  }),

  methods: {
    getTopOrderProduct() {
      axios
        .get(`hms/dash-board/top-ordered-product`)
        .then((resp) => {
          this.TopOrderProduct = resp.data.data;
        })
        .catch((err) => {
          reject(err.response);
        });
    },
  },
  created() {
    this.getTopOrderProduct();
  },
};
</script>
<style scoped>
</style>
